export default class GHParam {
  constructor (name, nickName) {
    this.name = name;
    this.nickName = nickName;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/GHParam.js